import { render, staticRenderFns } from "./SlidesPopup.vue?vue&type=template&id=4b0b32b2&scoped=true&"
import script from "./SlidesPopup.vue?vue&type=script&lang=js&"
export * from "./SlidesPopup.vue?vue&type=script&lang=js&"
import style0 from "./SlidesPopup.vue?vue&type=style&index=0&id=4b0b32b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0b32b2",
  null
  
)

export default component.exports